import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { questionValidation } from '../../functions/Validation';
import QuestionHelp from '../question/QuestionHelp';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';
import './customDropdown.scss';
import { IsWebReference } from '../../functions/Configuration';

export default function NativeDropdown(props: any) {

    const [question, setQuestion] = useState(props.question);
    const [dropdownValue, setDropdownValue] = useState(question.answer);
    const [inputLoaded, setInputLoaded] = useState(false);
    const [showRadioButtons, setShowRadioButtons] = useState(false);
    const [showDropdown, setShowDropdown] = useState(true);
    const [otherSelected, setOtherSelected] = useState(false);

    let companyStatus = localStorage.getItem('status') || "";
    const answerList = props.options ?? props.question.answerList ?? [];

    var inputClasses = classNames(
        {
            'dropdown-input': true,
            'validation-fail': question.validationFail
        }
    );

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );

        const radioClasses = (value: string) => {
        if (value == 'other') {
            return classNames({
                'radio-btn': true,
                'validation-fail': question.validationFail,
                'selected': otherSelected === true
            })
        }
        else {
            return classNames({
                'radio-btn': true,
                'validation-fail': question.validationFail,
                'selected': value === dropdownValue
            })
        }
    };

    const validateAnswer = () => {
        if (inputLoaded) {
            if (IsWebReference("TL") && companyStatus === "limited" && (question.questionSetQuestion.text.toLowerCase() === "how many directors carry out manual work?" || question.questionSetQuestion.text.toLowerCase() === "how many directors are there that carry out clerical work only?") && question.answer !== "") {
                // don't do standard validation for related questions as it overrides the other validation 
            } else {
                tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
                question.validationFail = !questionValidation(question);
                props.setIndividualCustomerDetails(question);
                props.enableQuestions(question.questionSetQuestion.questionID);
                setQuestion(question);
            }
        }
    };

    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setDropdownValue(props.question.answer);
            let dropDownText = "";
            if (answerList.find((x: { value: any; }) => x.value === props.question.answer) !== undefined) {
                dropDownText = answerList.find((x: { value: any; }) => x.value === props.question.answer).text;
            }
        }

        document.addEventListener("updateAnswer", function (e) {
            let eventDetails: any = e;
            if (eventDetails.detail.questionID === question.questionSetQuestion.questionID) {
                setDropdownValue(eventDetails.detail.answer);
            }
        });

        if (primaryRadioOptions.length) {
            setShowRadioButtons(true);
            setShowDropdown(false);
        }

        setInputLoaded(true);
    }, []);

    useEffect(() => {
        if (inputLoaded) {
            question.answer = dropdownValue;
            setQuestion(question);
            props.setIndividualCustomerDetails(question);
            props.showConditionQuestions(question.questionSetQuestion.questionID, dropdownValue);
            props.enableQuestions(question.questionSetQuestion.questionID);
            props.resetRelatedQuestionsValidationOnAnswerChange(question.questionSetQuestion.questionID, dropdownValue);
            if (props.questionIdPosition !== undefined) {
                if ((props.questionIdPosition.split('|').length - 1) === 1) {
                    let questionIdPositionItems = props.questionIdPosition.split('|');
                    let parentID = questionIdPositionItems[0].split('-')[0];
                    let childID = questionIdPositionItems[1].split('-')[0];
                    let childIndex = questionIdPositionItems[1].split('-')[1];

                    props.showConditionalChildren(parentID, dropdownValue, childID, childIndex);
                }

                if ((props.questionIdPosition.split('|').length - 1) === 2) {
                    let questionIdPositionItems = props.questionIdPosition.split('|');
                    let parentID = questionIdPositionItems[0].split('-')[0];
                    let parentChildID = questionIdPositionItems[1].split('-')[0];
                    let parentChildIndex = questionIdPositionItems[1].split('-')[1];
                    let childID = questionIdPositionItems[2].split('-')[0];
                    let childIndex = questionIdPositionItems[2].split('-')[1];

                    props.showConditionalChildren(parentID, dropdownValue, parentChildID, parentChildIndex, childID, childIndex);
                }
            }
        }
    }, [dropdownValue]);

    const selectOption = (value: string, text: string) => {
        setDropdownValue(value);
        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        if (value !== "" && question.questionSetQuestion.mandatory) {
            question.validationFail = false;
        }

        if (props.isRepeatable) {
            props.updateRepeatableAnswer(value);
        }

        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
    }

    const primaryRadioOptions = (() => {

        //Check and include all props.primaryAnswers that match answerList
        const matchedAnswers: any[] = [];
        if (props.primaryAnswers?.length) {
            const answersMap = new Map<string, any>();
            for (const answer of answerList) {
                answersMap.set(answer.text, answer);
            }


            for (const answer of props.primaryAnswers) {
                const primaryAnswerFound = answersMap.get(answer);
                if (primaryAnswerFound) matchedAnswers.push(primaryAnswerFound);
            }
        }
        return matchedAnswers
    })();

    const selectPrimary = (value: string, text?: string) => {
        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        setShowDropdown(false);
        setOtherSelected(false);
        question.validationFail = false;
        setDropdownValue(value);//Also triggers questions object update for page loaded
    }

    const showOther = () => {
        setShowDropdown(true);
        setOtherSelected(true);
        question.validationFail = true;
        question.answer = "";
        setDropdownValue("");
    }

    return (
        <>
            <div className="question">
                {!props.hideLabel && (
                    <>
                        <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>{question.questionSetQuestion.text}</label>
                        <br />
                    </>
                )}
                {showRadioButtons &&
                    <div className="primary-radio-container">
                        {primaryRadioOptions.map(answer => (
                            <button
                                id={"valen_" + question.questionSetQuestion.questionID + "_" + answer.text}
                                value={answer.value}
                                name={question.questionSetQuestion.questionID}
                                className={radioClasses(answer.value)}
                                onClick={() => selectPrimary(answer.value, answer.text)}
                            >{answer.text}</button>
                        ))}
                        <button
                            id={"valen_" + question.questionSetQuestion.questionID + "_other"}
                            value={"other"}
                            name={question.questionSetQuestion.questionID}
                            className={radioClasses("other")}
                            onClick={() => showOther()}
                        >Other</button>


                    </div>
                }
                {showDropdown && <>
                    <div className="other">
                        {props.hideLabel && (
                            <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>
                                {"Other: " + question.questionSetQuestion.text}
                            </label>
                        )}
                        <div className="dropdown-container">
                            <div className="dropdown-inner">
                                <select
                                    id={"valen_" + question.questionSetQuestion.questionID}
                                    className={inputClasses}
                                    value={dropdownValue}
                                    onBlur={() => validateAnswer()}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const text = e.target.options[e.target.selectedIndex].text;
                                        selectOption(value, text);
                                    }}
                                >
                                    <option value=""></option>
                                    {answerList.map((item: { value: string; text: string }, index: string) => (
                                        <option key={item.value + "_" + index} value={item.value}>
                                            {item.text}
                                        </option>
                                    ))}
                                </select>

                                {question.questionSetQuestion.helpText && (
                                    <QuestionHelp
                                        helpText={question.questionSetQuestion.helpText}
                                        questionID={question.questionSetQuestion.questionID}
                                    />
                                )}
                                <br />
                            </div>
                        </div>
                    </div>
                </>}
                {question.validationFail && (!props.isRepeatable || question.answer === "") &&
                    <ValidationMessage question={question} overrideMessage="Please select an option" />}
            </div>
        </>

    );
};